export default {
  region: process.env.REACT_APP_REGION,
  env: process.env.NODE_ENV,
  root: 'https://green.ptwiredapi.com/prod',
  appSync: 'green',
  timeoutInMinutes: process.env.REACT_APP_TIMEOUT_MINUTES,
};
